// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-slider:not(.ant-slider-disabled) .ant-slider-rail {
  background-color: #dee3ec;
}
.ant-slider:not(.ant-slider-disabled) .ant-slider-step .ant-slider-dot {
  border-color: #59606d;
}
.ant-slider:not(.ant-slider-disabled) .ant-slider-step .ant-slider-dot-active {
  border-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-slider:not(.ant-slider-disabled) .ant-slider-track {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-slider:not(.ant-slider-disabled) .ant-slider-handle::after {
  box-shadow: 0 0 0 2.5px rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-slider:not(.ant-slider-disabled) .ant-slider-handle:focus::after {
  box-shadow: 0 0 0 2.5px rgb(var(--color-primary-none, 89, 96, 109));
  outline: 6px solid rgba(var(--color-primary-none, 89, 96, 109), 0.2);
}
.ant-slider:not(.ant-slider-disabled) .ant-slider-handle:hover::after {
  box-shadow: 0 0 0 2.5px rgba(var(--color-primary-none, 89, 96, 109), 0.9);
  outline: 6px solid rgba(var(--color-primary-none, 89, 96, 109), 0.2);
}
.ant-slider:not(.ant-slider-disabled) .ant-slider-mark .ant-slider-mark-text {
  font-size: 10px;
}
.ant-slider:hover .ant-slider-handle::after {
  box-shadow: 0 0 0 2.5px rgba(var(--color-primary-none, 89, 96, 109), 0.9);
}
.ant-slider:hover .ant-slider-rail {
  background-color: #eceff4;
}
.ant-slider.ant-slider-disabled .ant-slider-rail {
  background-color: #dee3ec !important;
}
.ant-slider.ant-slider-disabled .ant-slider-track {
  background-color: #b1baca !important;
}
.ant-slider.ant-slider-disabled .ant-slider-step .ant-slider-dot {
  border-color: #b1baca;
}
.ant-slider.ant-slider-disabled .ant-slider-handle::after {
  box-shadow: 0 0 0 2px #b1baca;
  outline: none;
}
.ant-slider-disabled .ant-slider-step .ant-slider-dot-active {
  border-color: rgba(0, 0, 0, 0.04);
}
.ant-slider:hover .ant-slider-track {
  background-color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);
}
`, "",{"version":3,"sources":["webpack://./src/exports/slider/slider.less"],"names":[],"mappings":"AAEA;EAEQ,yBAAA;AAFR;AAAA;EAOY,qBAAA;AAJZ;AAHA;EAUY,yDAAA;AAJZ;AANA;EAeQ,6DAAA;AANR;AATA;EAmBQ,mEAAA;AAPR;AAZA;EAsBQ,mEAAA;EACA,oEAAA;AAPR;AAhBA;EA0BQ,yEAAA;EACA,oEAAA;AAPR;AApBA;EAgCY,eAAA;AATZ;AAcA;EAEQ,yEAAA;AAbR;AAWA;EAKQ,yBAAA;AAbR;AAiBA;EAEQ,oCAAA;AAhBR;AAcA;EAKQ,oCAAA;AAhBR;AAWA;EASY,qBAAA;AAjBZ;AAQA;EAaQ,6BAAA;EACA,aAAA;AAlBR;AAsBA;EAGY,iCAAA;AAtBZ;AA2BA;EAEQ,mEAAA;AA1BR","sourcesContent":["@import '../../less/color-vars.less';\n\n.ant-slider:not(.ant-slider-disabled) {\n    .ant-slider-rail {\n        background-color: @gray-30;\n    }\n\n    .ant-slider-step {\n        .ant-slider-dot {\n            border-color: @gray-80;\n        }\n        .ant-slider-dot-active {\n            border-color: @primary;\n        }\n    }\n\n    .ant-slider-track {\n        background-color: @primary;\n    }\n\n    .ant-slider-handle::after {\n        box-shadow: 0 0 0 2.5px @primary;\n    }\n    .ant-slider-handle:focus::after {\n        box-shadow: 0 0 0 2.5px @primary;\n        outline: 6px solid rgba(var(--color-primary-none, 89,96,109), 0.2);\n    }\n    .ant-slider-handle:hover::after {\n        box-shadow: 0 0 0 2.5px @primary-hover;\n        outline: 6px solid rgba(var(--color-primary-none, 89,96,109), 0.2);\n    }\n\n    .ant-slider-mark {\n        .ant-slider-mark-text {\n            font-size: 10px;\n        }\n    }\n}\n\n.ant-slider:hover {\n    .ant-slider-handle::after {\n        box-shadow: 0 0 0 2.5px @primary-hover\n    }\n    .ant-slider-rail {\n        background-color: @gray-20;\n    }\n}\n\n.ant-slider.ant-slider-disabled {\n    .ant-slider-rail {\n        background-color: @gray-30 !important;\n    }\n    .ant-slider-track {\n        background-color: @gray-50 !important;\n    }\n    .ant-slider-step {\n        .ant-slider-dot {\n            border-color: @gray-50;\n        }\n    }\n    .ant-slider-handle::after {\n        box-shadow: 0 0 0 2px @gray-50;\n        outline: none;\n    }\n}\n\n.ant-slider-disabled {\n    .ant-slider-step {\n        .ant-slider-dot-active {\n            border-color: rgba(0,0,0,0.04);\n        }\n    }\n}\n\n.ant-slider:hover {\n    .ant-slider-track {\n        background-color: @primary-hover;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
